const customSelectors = {};
class customJS {
    constructor() {
        let clickTargetAll = document.querySelectorAll('[data-slider-tabs] a');
        if (document.querySelector('[data-slider-tabs] a') != null) {
            clickTargetAll.forEach(clickTarget => {
                clickTarget.addEventListener('click', (event) => {
                    let getAttributeData = clickTarget.getAttribute('href').replace('#', '');
                    let sliderElement = document.getElementById(getAttributeData);
                    sliderElement = sliderElement.querySelector('[data-in-slider] .swiper');
                    let sliderOptions = sliderElement.getAttribute('data-slider');
                    let thumbSlider;
                    sliderOptions = JSON.parse(sliderOptions);
                    let slider = new Swiper(sliderElement, sliderOptions);
                    clickTarget.click();
                });
            });
            document.querySelector('[data-slider-tabs] a').click();
        }
    }
}

typeof customJS !== 'undefined' && new customJS();
